export const ANONYMOUS_USER = 'ANONYMOUS';

export const FEATURE_FLAGS = Object.freeze({
  // EXAMPLE_FEATURE_FLAG: 'example-feature-flag',
  NEW_CATEGORY_CARDS: 'new-category-cards',
  INITIAL_SEARCH_LAUNCH: 'initial-search-launch',
  SEARCH_ON_ENTER_VS_KEYSTROKE: 'search-on-enter-vs-keystroke',
  DIGITAL_HEALTH_NEW_LAYOUT: 'digital-health-new-layout',
});
